import React  from 'react';
import "./AllTours.css";

const AllTours = React.memo(props => {
    return (
        <div className="currentTour">
        <div className="linkImg">

           <img src={props.item.MODFocusImage.ImageUrl+"?RenditionID=7"} data-holder-rendered="true"  alt={"תמונת סיור " + props.item.Title}/>
        </div>
        <div className="linkDetails">
            <h3 alt={props.item.Title}>{props.item.Title}</h3>
            <div className="textWrap">
                <div className="linkInnerText" dangerouslySetInnerHTML={{__html: props.item.MODFocusMainText}}></div>
                {props.item.ModAttachLink && <div className="linkWrap"> 
                    {/* <i className="far fa-file-alt"></i> */}
                    <a href={props.item.ModAttachLink_Url} title={props.linkTitle}> 
                    <img src="/_layouts/15/images/sites/Museums/Pages/attach.png" />
                        <span> {props.linkTitle} </span>
                       </a>
                </div>}
            </div>
        </div>
        </div>
    );
});
    export default AllTours;